import { useParams } from "react-router-dom";
import LoadingSpinner from "../../loader/Loader";
import "./subscriptions.scss";
import { useGetSubscriptionByIdQuery, useUpdateSubscriptionStatusMutation } from "../../../features/api/subscriptionApiSlice";

const SubscriptionDetail = () => {
  const { id } = useParams();
  const {
    data: subscription,
    isLoading,
    refetch,
  } = useGetSubscriptionByIdQuery(id);
  const [updateStatus, {isLoading: statusLoading}] = useUpdateSubscriptionStatusMutation();

  const handleStatusChange = async (newStatus) => {
    try {
      await updateStatus({ id, status: newStatus }).unwrap();
      refetch();
    } catch (err) {
      console.error("Failed to update status", err);
    }
  };

  if (isLoading || statusLoading) return <LoadingSpinner />;
  if (!subscription) return <p>Not found</p>;

  return (
    <div className="admin-subscription-detail">
      <h2>
        Subscription Detail – {subscription.userId?.firstName}{" "}
        {subscription.userId?.lastName}
      </h2>

      <div className="subscription-card">
        <p>
          <strong>Plan:</strong> {subscription.type}
        </p>
        <p>
          <strong>Status:</strong> {subscription.status}
        </p>
        <p>
          <strong>Start Date:</strong>{" "}
          {new Date(subscription.startDate).toLocaleDateString()}
        </p>
        <p>
          <strong>End Date:</strong>{" "}
          {new Date(subscription.endDate).toLocaleDateString()}
        </p>

        {/* Action Buttons */}
        <div className="actions">
          {subscription.status !== "suspended" &&
            subscription.status !== "canceled" && (
              <button
                className="suspend"
                onClick={() => handleStatusChange("suspended")}
              >
                Suspend
              </button>
            )}
          {subscription.status !== "canceled" && (
            <button
              className="cancel"
              onClick={() => handleStatusChange("canceled")}
            >
              Cancel
            </button>
          )}
          {subscription.status !== "active" && (
            <button
              className="reactivate"
              onClick={() => handleStatusChange("active")}
            >
              Reactivate
            </button>
          )}
        </div>
      </div>

      <div className="history">
        <h3>Status History</h3>
        {subscription.statusHistory
          .slice()
          .reverse()
          .map((h, idx) => (
            <div className="history-item" key={idx}>
              <div className="status-info">
                <div className="status">{h.status}</div>
                {h.note && <div className="note">{h.note}</div>}
              </div>
              <div className="timestamp">
                <div>{new Date(h.changedAt).toLocaleString()}</div>
                <div className="source">via {h.source}</div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
export default SubscriptionDetail;
